import axios from 'axios';
import qs from 'qs';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IStemdoer } from '@/shared/model/stemdoer.model';
import { IExperience } from '@/shared/model/experience.model';

const baseApiUrl = 'api/stemdoers';
export default class StemdoerService {
  public find(id: string, isHidden?: boolean): Promise<IStemdoer> {
    return new Promise<IStemdoer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`, {
          params: {
            isHidden: isHidden
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveStemdoersByDate(date: Date, verticalId?: string, clientId?: string, paginationQuery?: any): Promise<any> {
    const dateFormatted = date.toISOString().split('T')[0];
    const params: any = {
      date: dateFormatted,
      ...paginationQuery
    };
    if (verticalId) params.verticalId = verticalId;
    if (clientId) params.clientId = clientId;

    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/date`, { params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public hideIt(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/hide/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IStemdoer): Promise<IStemdoer> {
    return new Promise<IStemdoer>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IStemdoer): Promise<IStemdoer> {
    return new Promise<IStemdoer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IStemdoer): Promise<IStemdoer> {
    return new Promise<IStemdoer>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findExperience(stemdoerId: string, experienceId: string): Promise<IExperience> {
    return axios
      .get(`${baseApiUrl}/${stemdoerId}/experience/${experienceId}`)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public createExperience(stemdoerId: string, entity: IExperience): Promise<IExperience> {
    return axios
      .post(`${baseApiUrl}/${stemdoerId}/experience`, entity)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public updateExperience(stemdoerId: string, experienceId: string, entity: IExperience): Promise<IExperience> {
    return axios
      .put(`${baseApiUrl}/${stemdoerId}/experience/${experienceId}`, entity)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public partialUpdateExperience(stemdoerId: string, experienceId: string, entity: IExperience): Promise<IExperience> {
    return axios
      .patch(`${baseApiUrl}/${stemdoerId}/experience/${experienceId}`, entity)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public deleteExperience(stemdoerId: string, experienceId: string): Promise<void> {
    return axios
      .delete(`${baseApiUrl}/${stemdoerId}/experience/${experienceId}`)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public retrieveByClientTeams(clientId: string, date: Date, byCompany?: Boolean, paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const formattedDate = date.toISOString().split('T')[0];
      axios
        .get(`${baseApiUrl}/teams/${clientId}?date=${formattedDate}&${buildPaginationQueryOpts(paginationQuery)}`, {
          params: {
            byCompany: byCompany
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getOffices(): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/offices`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createTechnologyScores(stemdoerId: string, entity: any): Promise<any> {
    return axios
      .post(`${baseApiUrl}/${stemdoerId}/technology-scores`, entity)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public partialUpdateTechnologyScore(stemdoerId: string, idTechnology: number, entity: any): Promise<any> {
    return axios
      .patch(`${baseApiUrl}/${stemdoerId}/technology-scores/${idTechnology}`, entity)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public updateTechnologyScores(stemdoerId: string, entities: any[]): Promise<any> {
    return axios
      .put(`${baseApiUrl}/${stemdoerId}/technology-scores`, entities)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  public partialUpdateSeniority(id: string, seniority: string): Promise<any> {
    return axios
      .patch(
        `${baseApiUrl}/${id}/seniority`,
        { seniority },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        throw err;
      });
  }

  /**
   * Recupera los stemdoers en proyectos activos de una compañía (por CIF), con filtro opcional de verticales y paginación.
   * @param companyCif CIF de la compañía
   * @param date Fecha de referencia (Date)
   * @param vIds Array de verticales (opcional)
   * @param paginationQuery Objeto de paginación (opcional)
   */
  public retrieveStemdoersByCompanyProjects(companyCif: string, date: Date, vIds?: string[], paginationQuery?: any): Promise<any> {
    const dateFormatted = date.toISOString().split('T')[0];
    const params: any = {
      date: dateFormatted,
      ...paginationQuery
    };
    if (vIds && vIds.length > 0) params.vIds = vIds;
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/projects/${companyCif}`, {
          params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
